import React from 'react';
import { defaultColors, productColors } from '@givebutter/util';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styled, { css } from 'styled-components';

interface TooltipThemeProps {
    inverse?: boolean;
    className?: string;
}

const TooltipContentWrapper = React.forwardRef(
    ({ inverse, ...props }: TooltipThemeProps, ref: React.Ref<HTMLDivElement>) => (
        <TooltipPrimitive.Content ref={ref} {...props} />
    ),
);

const TooltipArrowWrapper = React.forwardRef(
    ({ inverse, ...props }: TooltipThemeProps, ref: React.Ref<SVGSVGElement>) => (
        <TooltipPrimitive.Arrow ref={ref} {...props} />
    ),
);

const PopoverContentStyles = css`
    z-index: ${props => props.theme.zIndex.PentOutermost};
    margin: 0;
    border-radius: ${props => props.theme.radius.large};
    box-shadow: ${props => props.theme.shadows.popover};
    border: none;
    background-color: white;
`;

const TooltipPopoverContentStyles = css<TooltipThemeProps>`
    max-width: 300px;
    padding: 0.5rem 0.75rem;
    background: ${props => (props.inverse ? productColors.gray[900] : defaultColors.white)};
`;

const TooltipContent = styled(TooltipContentWrapper)<TooltipThemeProps>`
    ${PopoverContentStyles};
    ${TooltipPopoverContentStyles}

    & * {
        color: ${props => (props.inverse ? defaultColors.white : productColors.gray[900])};
        font-size: ${props => props.theme.fontSize.sm};
    }
`;

const TooltipContentNoStyles = styled(TooltipContentWrapper)<TooltipThemeProps>`
    ${PopoverContentStyles};
    ${TooltipPopoverContentStyles}
`;

const TooltipArrow = styled(TooltipArrowWrapper)<TooltipThemeProps>`
    fill: ${props => (props.inverse ? productColors.gray[900] : defaultColors.white)};
`;

export { TooltipContent, TooltipContentNoStyles, TooltipArrow };
export type { TooltipThemeProps };
